import { useEffect, useState } from "react";
import { api } from "../../../lib/chalkApi";

/**
 * Loads + reshapes the user's current subscription into the two banner
 * states the Chalkboard needs: an active trial (`trial`) and an
 * expired/cancelled state (`expired`). Only one is non-null at a time.
 *
 * Returns { trial, expired, reload } so callers can refresh after a renew.
 */
export function useChalkboardSubscription() {
  const [trial, setTrial] = useState(null);
  const [expired, setExpired] = useState(null);

  function applyState(d) {
    const s = d.subscription;
    if (s && s.status === "trialing" && typeof s.trial_days_left === "number") {
      setTrial(s); setExpired(null);
    } else if (d.expired) {
      setTrial(null); setExpired(d.expired);
    } else {
      setTrial(null); setExpired(null);
    }
  }

  async function reload() {
    try {
      const d = await api.mySubscription();
      applyState(d);
    } catch { /* keep last state */ }
  }

  useEffect(() => {
    let cancelled = false;
    api.mySubscription().then((d) => { if (!cancelled) applyState(d); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return { trial, expired, reload };
}
